<template>
  <!-- 画像枠は常に固定アスペクト比(3:2)で囲み、カード高さを一定にする -->
  <template v-if="hasNoImage">
    <div class="aspect-[3/2] w-full overflow-hidden">
      <img alt="no-image" src="@/assets/img/no-image.svg" :class="imageClass" />
    </div>
  </template>
  <template v-else-if="!shouldOutputMultipleImages">
    <!-- 体験一覧検索 -->
    <div class="aspect-[3/2] w-full overflow-hidden">
      <OptimizedImage alt="experience-image" :class="imageClass" :image-url="images[0].imageUrl" :optimized-image-options="{ width: 560 }" />
    </div>
  </template>
  <template v-else>
    <Carousel v-if="shouldOutputMultipleImages">
      <CarouselContent>
        <CarouselItem v-for="image in images" :key="image.id">
          <!-- TOP Recently viewd 一覧検索カルーセル -->
          <div class="aspect-[3/2] w-full overflow-hidden">
            <OptimizedImage alt="experience-image" loading="lazy" :class="imageClass" :image-url="image.imageUrl" :optimized-image-options="{ width: 560 }" />
          </div>
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselNext v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselDotIndicator class="md:hidden md:group-hover:flex" />
    </Carousel>
  </template>
</template>

<script setup lang="ts">
import { Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselDotIndicator } from '@/components/lib/shadcn-vue/carousel';
import CarouselItem from '@/components/lib/shadcn-vue/carousel/CarouselItem.vue';
import { useIsSP } from '@/composables/ui/useIsSP';
import type { WabunkaExperienceImageListViewModel } from '@/models/wabunka/wabunkaExperience';
import { OptimizedImage } from '@/wabunka-src/common/components';
interface Props {
  displayMultipleImages: boolean;
  images: WabunkaExperienceImageListViewModel;
  isVertical: boolean;
}
const props = defineProps<Props>();

const hasNoImage = computed<boolean>(() => props.images.length === 0);
const shouldOutputMultipleImages = computed<boolean>(() => props.displayMultipleImages && props.images.length > 1);
// 固定アスペクト枠を埋める object-cover
const imageClass = 'transition-all duration-500 md:group-hover:scale-[102%] h-full w-full object-cover';
const isSP = useIsSP();
</script>
